module.exports = __webpack_public_path__ + "static/media/meta-ui.978c1206.png";